import React, { useState, useContext, useRef, useEffect } from 'react';
import { useNavigate, useLocation, matchPath } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Button,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import SearchIcon from '@material-ui/icons/Search';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import LogoDashboard from './LogoDashboard';
import GlobalMenu from "./GlobalMenu"

import { logout } from "../utils/auth"
import getInitials from '../utils/getInitials';

import folderIcon from "../images/folderIcon.svg"
import rectBlackCheckWhite from "../images/rectBlackCheckWhite.svg"


import UserAdminClientContext from "../contexts/UserAdminClientContext"
import LanguageContext from "../contexts/LanguageContext"


const DashboardNavbarAdminClient = ({ ...props }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuRef = useRef(null);

  const [selectEcoleDropdown, setSelectEcoleDropdown] = useState(false)
  const [searchEcole, setSearchEcole] = useState("")
  const [filteredEcoles, setFilteredEcoles] = useState([])

  const [menuMobileDropdown, setMenuMobileDropdown] = useState(false)

  const globalMenuRef = useRef(null)
  const [globalMenu, setGlobalMenu] = useState(false)

  const {
    actPage,
    actEcoleID,
    actEcole,
    userLoaded,
    ecoles,
    updateActEcole,
    currentUser,
    updateUserContext,
  } = useContext(UserAdminClientContext)

  const {
    actLanguage,
    languageValues,
  } = useContext(LanguageContext)

  const itemsMenu = [
    {
      page: 'home',
      title: languageValues?.adminDashboard?.home[actLanguage],
    },
    {
      page: 'suivi',
      title: languageValues?.adminDashboard?.monitoring[actLanguage],
    },
    {
      page: 'progression',
      title: languageValues?.adminDashboard?.mapping[actLanguage],
    },
    {
      page: 'certification',
      title: languageValues?.adminDashboard?.certification[actLanguage],
    },
  ];

  const handleOutsideClick = (e) => {
    if (globalMenuRef.current && !globalMenuRef.current.contains(e.target)) {
      setGlobalMenu(false)
    }
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setSelectEcoleDropdown(false)
    }
    if (observedElementRef.current && !observedElementRef.current.contains(e.target)) {
      if (e?.target?.classList?.contains("customForClickMenuMobile")) {
        e?.target?.classList?.forEach((classe) => {
          if (classe?.includes("goToPage-")) {
            let pageID = classe?.replace("goToPage-", "")
            let find = itemsMenu?.find((el) => el.page === pageID)
            if (find) {
              updateActEcole(actEcole?.ecoleID, find?.page);
            }
          }
        })
      }
      setMenuMobileDropdown(false)
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [actEcole]);

  useEffect(() => {
    if (selectEcoleDropdown === false) {
      setSearchEcole("")
    }
  }, [selectEcoleDropdown])

  useEffect(() => {
    if (searchEcole?.length === 0) {
      setFilteredEcoles(ecoles)
    } else {
      let newEcoles = ecoles?.filter((el) => {
        let indexOf = el?.name?.trim()?.toLowerCase()?.indexOf(searchEcole?.trim()?.toLowerCase())
        if (indexOf >= 0) { return true } else { return false }
      })
      setFilteredEcoles(newEcoles)
    }
  }, [ecoles, searchEcole])

  const theme = useTheme();
  const mediaQueryUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const observedElementRef = useRef(null);
  const [leftOffsetForMobileMenu, setLeftOffsetForMobileMenu] = useState(99999)
  const [widthForMobileMenu, setWidthForMobileMenu] = useState(0)
  useEffect(() => {
    if (observedElementRef.current) {
      const observer = new ResizeObserver(debounce((entries) => {
        for (let entry of entries) {
          setLeftOffsetForMobileMenu(observedElementRef?.current?.getBoundingClientRect()?.left - 11)
          setWidthForMobileMenu(observedElementRef?.current?.getBoundingClientRect()?.width + 11)
          return
        }
      }));
      observer.observe(observedElementRef?.current);
      return () => {
          observer.disconnect();
      };
    }
  }, [observedElementRef?.current, mediaQueryUpMd, mediaQueryUpSm]);

  useEffect(() => {
    if (mediaQueryUpMd === true && menuMobileDropdown === true) {
      setMenuMobileDropdown(false)
    }
  }, [mediaQueryUpMd, menuMobileDropdown])

  const getActPageForMenuMobile = () => {
    let find = itemsMenu?.find((el) => el.page === actPage)
    if (find) {
      return find?.title
    }
    return ""
  }

  return (
    <AppBar
      elevation={0}
      sx={{background:"#FFFFFF", borderBottom:"1px solid black"}}
      {...props}
    >
      <Toolbar
        sx={{
          height: ["55px !important", "65px !important"],
          minHeight: ["55px !important", "65px !important"],
          background:"#FFFFFF",
        }}>
        <Box sx={{
          display:"flex",
          alignItems:"center",
          height:"100%",
          maxWidth:"calc(100vw - 100px)",
        }}>
          <Box sx={{
            marginLeft:"5px",
            marginRight:["0px", "25px"],
            paddingRight:["15px", "0px"],
            display:"flex",
            alignItems:"center",
            cursor:"pointer",
            borderRight:["2px solid #E6E6E7", "0"],
          }} onClick={() => navigate("/")}>
            <LogoDashboard />
          </Box>
          <Hidden smDown>
            <Box ref={menuRef} sx={{
              width:"250px",
              height:"100%",
              borderLeft:"1px solid black",
              borderRight:"1px solid black",
              background:"#EFEFEF",
              position:"relative",
              color:"text.secondary",
              userSelect:"none",
            }}>
              {ecoles?.length > 0 &&
                <>
                  <Box
                    onClick={() => { setSelectEcoleDropdown(!selectEcoleDropdown) }}
                    sx={{
                      display:"flex",
                      height:"100%",
                      alignItems:"center",
                      padding:"15px",
                      overflow:"hidden",
                      cursor:"pointer",
                      gap:"8px",
                    }}
                  >
                    <img src={folderIcon} style={{width:"23px"}}/>
                    <span style={{
                      textTransform:"capitalize",
                      whiteSpace:"nowrap",
                      overflow:"hidden",
                      textOverflow:"ellipsis",
                    }}>{actEcole?.name}</span>
                    <KeyboardArrowDownIcon sx={{
                      transform:selectEcoleDropdown === true && "rotate(180deg)",
                    }}/>
                  </Box>
                  {selectEcoleDropdown === true &&
                    <Box sx={{
                      width:"250px",
                      position: "absolute",
                      background:"white",
                      top: "66px",
                      left:"-1px",
                      borderLeft:"1px solid black",
                      borderRight:"1px solid black",
                      borderBottom:"1px solid black",
                      boxShadow: "0px 1px 20px rgba(0, 0, 0, 0.1)",
                      cursor:"pointer",
                    }}>
                      <TextField
                        fullWidth
                        name="search"
                        type="text"
                        value={searchEcole}
                        variant="standard"
                        placeholder={languageValues?.search[actLanguage]}
                        onChange={(e) => {
                          setSearchEcole(e.target.value);
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiInputBase-root" : {
                            height: "50px",
                            padding: "15px",
                          },
                          "& .MuiInputBase-input" : {
                            padding: "0px",
                          },
                        }}
                      />
                      <Box sx={{
                        maxHeight:"450px",
                        overflowY:"auto",
                      }}>
                        {filteredEcoles?.map((ecole, index) => {
                          let active = false
                          if (ecole?.ecoleID === actEcoleID) {
                            active = true
                          }
                          return (
                            <Box
                              key={index}
                              onClick={() => { updateActEcole(ecole?.ecoleID, "home"); setSelectEcoleDropdown(false) }}
                              sx={{
                                height:"50px",
                                padding:"15px",
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                                gap:"8px",
                                justifyContent:"space-between",
                                backgroundColor:active && "background.grey"
                              }}
                            >
                              <Box sx={{
                                display:"flex",
                                alignItems:"center",
                                overflow:"hidden",
                                gap:"8px",
                              }}>
                                <img src={folderIcon} style={{width:"20px"}}/>
                                <span style={{
                                  textTransform:"capitalize",
                                  whiteSpace:"nowrap",
                                  overflow:"hidden",
                                  textOverflow:"ellipsis",
                                }}>{ecole?.name}</span>
                              </Box>
                              {active &&
                                <img src={rectBlackCheckWhite} style={{width:"20px",height:"20px",minWidth:"20px",}} />
                              }
                            </Box>
                          )
                        })}
                      </Box>
                    </Box>
                  }
                </>
              }
            </Box>
          </Hidden>
          <Hidden mdDown>
            <Box sx={{display:"flex", marginLeft:"25px", marginRight:"25px", justifyContent:"space-between", gap:"30px"}}>
              {itemsMenu.map((item, index) => {
                let active = false
                let split = window?.location?.pathname?.split('/')
                split = split.filter((el) => el !== '')
                if (split?.length === 3) {
                  if (split[2] === item?.page) {
                    active = true
                  }
                }
                return (
                  <Button
                    key={index}
                    disableRipple
                    onClick={() => {
                      updateActEcole(actEcoleID, item?.page)
                    }}
                    sx={{
                      fontSize:"16px",
                      color:"text.secondary",
                      textDecoration:active && "underline",
                      textUnderlineOffset: "6px",
                      minWidth:0,
                      "&:hover" : {
                        background:"transparent",
                        color:"rgba(0,0,0,0.75)",
                        textDecoration:active && "underline",
                      }
                    }}
                    size="small"
                  >
                    <span>
                      {item?.title}
                    </span>
                  </Button>
                )
              })}

            </Box>
          </Hidden>

          <Hidden mdUp>
            <Box ref={observedElementRef} sx={{display:"flex", marginLeft:"10px", marginRight:"0px", justifyContent:"space-between", gap:"30px", overflow:"hidden"}}>
              <Box
                onClick={() => { setMenuMobileDropdown(!menuMobileDropdown) }}
                sx={{
                  display:"flex",
                  height:"100%",
                  alignItems:"center",
                  padding:"15px",
                  overflow:"hidden",
                  cursor:"pointer",
                  gap:"8px",
                  color:"text.secondary",
                }}
              >
                <span style={{
                  textTransform:"capitalize",
                  whiteSpace:"nowrap",
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                }}>{getActPageForMenuMobile()}</span>
                <KeyboardArrowDownIcon sx={{
                  transform:menuMobileDropdown === true && "rotate(180deg)",
                }}/>
              </Box>
            </Box>
            {menuMobileDropdown === true &&
              <Box sx={{
                width:widthForMobileMenu+"px",
                position: "absolute",
                top:["56px", "66px"],
                left:leftOffsetForMobileMenu+"px",
                borderLeft:"1px solid black",
                borderRight:"1px solid black",
                borderBottom:"1px solid black",
                boxShadow: "0px 1px 20px rgba(0, 0, 0, 0.1)",
                cursor:"pointer",
                display:"flex",
                flexDirection:"column",
                overflow:"hidden",
                background:"white",
              }}>
                {itemsMenu.map((item, index) => {
                  let active = false
                  let split = window?.location?.pathname?.split('/')
                  split = split.filter((el) => el !== '')
                  if (split?.length === 3) {
                    if (split[2] === item?.page) {
                      active = true
                    }
                  }
                  return (
                    <Button
                      key={index}
                      className={"customForClickMenuMobile goToPage-"+item?.page}
                      disableRipple
                      sx={{
                        height:'50px !important',
                        minHeight:'50px !important',
                        fontSize:"15px !important",
                        color:"text.secondary",
                        textDecoration:active && "underline",
                        textUnderlineOffset: "6px",
                        minWidth:0,
                        "&:hover" : {
                          background:"transparent",
                          color:"rgba(0,0,0,0.75)",
                          textDecoration:active && "underline",
                        }
                      }}
                      size="small"
                    >
                      <span className={"customForClickMenuMobile goToPage-"+item?.page}>
                        {item?.title}
                      </span>
                    </Button>
                  )
                })}
              </Box>
            }
          </Hidden>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
        </Box>


        <GlobalMenu
          globalMenu={globalMenu}
          setGlobalMenu={setGlobalMenu}
          globalMenuRef={globalMenuRef}
          updateUserContext={updateUserContext}
          currentUser={currentUser}
        />


      </Toolbar>
    </AppBar>
  );
};


export default DashboardNavbarAdminClient;
